import { loadWidgetStandalone } from './widget-loader';

if (typeof window.GETE === 'undefined') {
    window.GETE = { loadWidget: loadWidgetStandalone };
} else {
    window.GETE.loadWidget = loadWidgetStandalone;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-bundle/_entry.standalone.ts